import s from "./index441.js";
import { createElementBlock as t, openBlock as r, createCommentVNode as a } from "vue";
import i from "./index231.js";
const m = ["data-component"], f = ["src", "height"];
function d(e, o, p, l, c, h) {
  return r(), t("div", {
    "data-component": e.$options.name
  }, [
    e.hasUserConsent ? (r(), t("iframe", {
      key: 0,
      ref: "iframeRef",
      src: e.url,
      class: "w-full",
      height: e.height,
      title: "Generic Title",
      onLoad: o[0] || (o[0] = (...n) => e.onLoad && e.onLoad(...n))
    }, null, 40, f)) : a("", !0)
  ], 8, m);
}
const g = /* @__PURE__ */ i(s, [["render", d]]);
export {
  g as default
};
